// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1KF4c","productName":"Table_productName__3AXVQ"};